<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listEmployees"
        sort-name="nome"
        title-table="Funcionários"
        module="employeesAdministrativeModule"
        view-permission="ROLE_FUNCIONARIO_CONSULTAR"
        edit-permission="ROLE_FUNCIONARIO_ATUALIZAR"
        delete-permission="ROLE_FUNCIONARIO_DELETAR"
        :show-btn-add="verificarPermissao('ROLE_FUNCIONARIO_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FUNCIONARIO_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <form-insert
        v-else
        :title-form="objectFormInsert.titleForm"
        :combo-type="comboTypesRegister"
        @cancelar="cancelar"
        @save="save"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import mixinsGlobal from "@/mixins";
import FormInsert from "@/layouts/components/FormInsert.vue";

export default {
  name: "Associantes",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormInsert,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("employeesAdministrativeModule", {
      listEmployees: (state) => state.listEmployees,
      employee: (state) => state.employee,
      comboTypesRegister: (state) => state.comboTypesRegister,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Matricula",
          field: "matricula",
        },
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Tipo Registro",
          field: "tipoRegisto",
        },
        {
          label: "Função",
          field: "funcao",
        },
        {
          label: "Data Admissão",
          field: "dataAdmissao",
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss'Z'",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "Data Demissão",
          field: "dataDemissao",
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss'Z'",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "Situação",
          field: "situacaoRegistro",
        },
        {
          label: this.$t("Action"),
          field: "action",
        },
      ],
      objectFormInsert: {
        titleForm: "Cadastro de Funcionario",
      },
      pageConfig: {
        page: 1,
        size: 10,
        sort: "nome",
        order: "asc",
      },
    };
  },
  mounted() {
    this.$store.dispatch(
      "employeesAdministrativeModule/loadComboTypesRegister",
    );
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$router.push({ path: `editEmployee/${data.id}` });
    },
    cancelar() {
      this.$store.dispatch("employeesAdministrativeModule/resetEmployee");
      this.showForm = false;
    },
    save(data) {
      this.$store
        .dispatch("employeesAdministrativeModule/insertNewEmployee", data)
        .then((response) => {
          this.showMessageSuccess("Salvo", "Incluido com sucesso!");
          this.cancelar();
          this.edit(response.data);
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.message || "Erro ao Inserir";
          this.MensagemError("Falha ao Inserir", errorMsg);
          this.showForm = true;
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
